export const supportedBookingSimplifiedCostCurrencies = [
  'PLN',
  // Europe (non-EUR)
  'ALL', 'AMD', 'AZN', 'BAM', 'BGN', 'BYN', 'CHF', 'CZK', 'DKK',
  'GEL', 'HUF', 'ISK', 'MDL', 'MKD', 'NOK', 'RON', 'RSD', 'RUB', 'SEK', 'UAH',
  // Eurozone
  'EUR',
  // North Africa
  'DZD', 'EGP', 'LYD', 'MAD', 'TND',
  // Turkey
  'TRY',
  // Other
  'GBP', 'USD',
] as const;

export type SupportedCurrency = (typeof supportedBookingSimplifiedCostCurrencies)[number];

export interface CurrencyOption {
  code: SupportedCurrency;
  label: string;
}

const currencyLabels: Record<SupportedCurrency, string> = {
  PLN: 'Złoty (Polska)',
  ALL: 'Lek (Albania)',
  AMD: 'Dram (Armenia)',
  AZN: 'Manat (Azerbejdżan)',
  BAM: 'Marka zamienna (Bośnia i Hercegowina)',
  BGN: 'Lew (Bułgaria)',
  BYN: 'Rubel (Białoruś)',
  CHF: 'Frank (Szwajcaria)',
  CZK: 'Korona (Czechy)',
  DKK: 'Korona (Dania)',
  GEL: 'Lari (Gruzja)',
  HUF: 'Forint (Węgry)',
  ISK: 'Korona (Islandia)',
  MDL: 'Lej (Mołdawia)',
  MKD: 'Denar (Macedonia Płn.)',
  NOK: 'Korona (Norwegia)',
  RON: 'Lej (Rumunia)',
  RSD: 'Dinar (Serbia)',
  RUB: 'Rubel (Rosja)',
  SEK: 'Korona (Szwecja)',
  UAH: 'Hrywna (Ukraina)',
  EUR: 'Euro (strefa euro)',
  DZD: 'Dinar (Algieria)',
  EGP: 'Funt (Egipt)',
  LYD: 'Dinar (Libia)',
  MAD: 'Dirham (Maroko)',
  TND: 'Dinar (Tunezja)',
  TRY: 'Lira (Turcja)',
  GBP: 'Funt (Wielka Brytania)',
  USD: 'Dolar (USA)',
};

export const currencyOptions: CurrencyOption[] =
  supportedBookingSimplifiedCostCurrencies.map((code) => ({
    code,
    label: currencyLabels[code],
  }));

export interface CreateBookingSimplifiedCostRequest {
  companyId: number;
  issueDate: string;
  totalGross: number;
  currency: SupportedCurrency;
  description: string;
  tagIds?: number[];
  assignmentTagId?: number | null;
}

export interface CreateBookingSimplifiedCostResponse {
  expenseInvoiceId: number;
  bookingId: number;
  allocatedAmount: number;
}

